import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { CartQuantityDiscountSelectBox } from './components/CartQuantityDiscountSelectBox/CartQuantityDiscountSelectBox.js';

const CartDiscountSelector = ({ className , isLoading , cartDiscountItems , activeDiscount , onItemClick , onReset ,  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.cartDiscount.title');
    const resetButtonCaption = getLabel('products.cartDiscount.action.reset');
    if (cartDiscountItems.length === 0) {
        return null;
    }
    if (isLoading) {
        // TODO CXRO-2212: add loading state
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('cart-discount-selector', className),
        "aria-label": title
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart-discount-selector__header"
    }, /*#__PURE__*/ React.createElement(H2, {
        className: "cart-discount-selector__title",
        variant: "heading-smallest"
    }, title), activeDiscount && /*#__PURE__*/ React.createElement(Button, {
        onClick: onReset,
        caption: resetButtonCaption,
        variant: "ghost",
        className: "cart-discount-selector__reset"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "cart-discount-selector__list"
    }, cartDiscountItems.map((discountItem, index)=>{
        const isSelected = discountItem === activeDiscount;
        return /*#__PURE__*/ React.createElement("li", {
            key: `${index}-${discountItem.minimumQuantity}`,
            className: "cart-discount-selector__list-item"
        }, /*#__PURE__*/ React.createElement(CartQuantityDiscountSelectBox, {
            item: discountItem,
            isSelected: isSelected,
            onClick: ()=>onItemClick(discountItem, isSelected)
        }));
    })));
};

export { CartDiscountSelector };
//# sourceMappingURL=CartDiscountSelector.js.map
